var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { reactive, ref, watch } from 'vue-demi';
const useScreenRecorder = (params = {}) => {
    const { options, audio = false } = params;
    const blobUrlRef = ref();
    const blobRef = ref();
    const errorRef = ref();
    const mediaRecorderRef = ref();
    const statusRef = ref('permission-requested');
    const streamsRef = ref({ audio: undefined, screen: undefined });
    watch(mediaRecorderRef, () => {
        if (mediaRecorderRef.value) {
            mediaRecorderRef.value.ondataavailable = (event) => {
                const url = window.URL.createObjectURL(event.data);
                blobUrlRef.value = url;
                blobRef.value = event.data;
            };
        }
    });
    const requestMediaStream = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            // @ts-ignore
            const displayMedia = yield navigator.mediaDevices.getDisplayMedia();
            let userMedia;
            if (audio) {
                userMedia = yield navigator.mediaDevices.getUserMedia({ audio });
            }
            // @ts-ignore
            const tracks = [...displayMedia === null || displayMedia === void 0 ? void 0 : displayMedia.getTracks(), ...((userMedia === null || userMedia === void 0 ? void 0 : userMedia.getTracks()) || [])];
            if (tracks)
                statusRef.value = 'idle';
            const stream = new MediaStream(tracks);
            const mediaRecorder = new MediaRecorder(stream, options);
            mediaRecorderRef.value = mediaRecorder;
            streamsRef.value = {
                audio: 
                // @ts-ignore
                userMedia === null || userMedia === void 0 ? void 0 : userMedia.getTracks().find(track => track.kind === 'audio'),
                screen: displayMedia
                    .getTracks()
                    .find((track) => track.kind === 'video')
            };
            return mediaRecorder;
        }
        catch (e) {
            errorRef.value = e;
            statusRef.value = 'error';
        }
    });
    const stopRecording = () => {
        if (!mediaRecorderRef.value)
            throw new Error('No media stream!');
        mediaRecorderRef.value.stop();
        statusRef.value = 'stopped';
        mediaRecorderRef.value.stream.getTracks().forEach((track) => {
            track.stop();
        });
        mediaRecorderRef.value = undefined;
    };
    const startRecording = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (!mediaRecorderRef.value) {
            mediaRecorderRef.value = yield requestMediaStream();
        }
        if (mediaRecorderRef.value) {
            (_a = mediaRecorderRef.value) === null || _a === void 0 ? void 0 : _a.start();
            statusRef.value = 'recording';
        }
    });
    const pauseRecording = () => {
        var _a;
        if (!mediaRecorderRef.value)
            throw new Error('No media stream!');
        (_a = mediaRecorderRef.value) === null || _a === void 0 ? void 0 : _a.pause();
        statusRef.value = 'paused';
    };
    const resumeRecording = () => {
        var _a;
        if (!mediaRecorderRef.value)
            throw new Error('No media stream!');
        (_a = mediaRecorderRef.value) === null || _a === void 0 ? void 0 : _a.resume();
        statusRef.value = 'recording';
    };
    const resetRecording = () => {
        blobUrlRef.value = undefined;
        blobRef.value = undefined;
        errorRef.value = undefined;
        mediaRecorderRef.value = undefined;
        statusRef.value = 'idle';
    };
    return reactive({
        blob: blobRef,
        blobUrl: blobUrlRef,
        error: errorRef,
        status: statusRef,
        streams: streamsRef,
        actions: {
            startRecording,
            stopRecording,
            pauseRecording,
            resetRecording,
            resumeRecording
        }
    });
};
export default useScreenRecorder;
